import PagePlaceholder from "./PagePlaceholder";

const OriginalOrders = () => <PagePlaceholder title="Original Orders" />;

export default OriginalOrders;
